//@flow
import {getHost, bypassCache} from '../../configs/index';
//import type { ThunkAction } from 'types/index'

type ThunkAction = Function;
// export const setCoinsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'coins', 'coins')

export const fetchCoins: () => ThunkAction = () => async function (dispatch, getState) {
  dispatch({type: 'data_requested_coins' })

  let url = getHost() + '/api/get-coins'
  url = bypassCache() ? url + `?nocache=true` : url // just a backdoor for me to test without chaching
  const response = await fetch(url)

  const coins = await response.json()

  dispatch({ type: 'value_received_coins' , payload: coins })
}

// export const setTwitterCountsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'twitterCounts', 'twitterCounts', null, true)
//
// export const setRedditCountsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'redditCounts', 'redditCounts', null, true)
//
// export const setTelegramCountsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'telegramCounts', 'telegramCounts', null, true)
//
// export const setMediumCountsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'mediumCounts', 'mediumCounts', null, true)
//
// export const setBitcointalkCountsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'bitcointalkCounts', 'bitcointalkCounts', null, true)
//
// export const setMCapsListener: () => ThunkAction = () => (disp, getS) =>
//   createFirebaseListener(disp, getS, 'mCaps', 'mCaps', null, true)



// WEBPACK FOOTER //
// ./src/actions/listeners/init.js